import { getCookie } from '@amagimedia/api-client';
import {
  ACCESS_TOKEN_PART_1_KEY,
  ACCESS_TOKEN_PART_2_KEY,
  ACCESS_TOKEN_PART_3_KEY,
  REFRESH_TOKEN_KEY,
} from '@amagimedia/api-client/src/constants';
import {
  AccessTokenPart1Cookie,
  AccessTokenPart2Cookie,
  AccessTokenPart3Cookie,
} from '@amagimedia/api-client/src/types';
import type { FC } from 'react';
import { createContext, useContext } from 'react';
import { ILoginDataStvV2 } from '../types/loginData';
import { gotoSignInPage } from '../utils';
import { parseJwtToken } from '../utils/jwtUtils';

const ValidateUserContext = createContext<ILoginDataStvV2 | null>(null);

interface IProps {
  data?: ILoginDataStvV2 | null;
}

export const ValidateUserProviderStvV2: FC<IProps> = (props) => {
  const accessTokenPart1 = getCookie<AccessTokenPart1Cookie>(
    ACCESS_TOKEN_PART_1_KEY,
  );
  const accessTokenPart2 = getCookie<AccessTokenPart2Cookie>(
    ACCESS_TOKEN_PART_2_KEY,
  );
  const accessTokenPart3 = getCookie<AccessTokenPart3Cookie>(
    ACCESS_TOKEN_PART_3_KEY,
  );
  const refreshTokenData = getCookie<AccessTokenPart1Cookie>(REFRESH_TOKEN_KEY);
  if (
    props.data &&
    !accessTokenPart1 &&
    !accessTokenPart2 &&
    !accessTokenPart3 &&
    !refreshTokenData
  ) {
    return (
      <ValidateUserContext.Provider value={props.data}>
        {props.children}
      </ValidateUserContext.Provider>
    );
  }
  if (
    !accessTokenPart1 &&
    !accessTokenPart2 &&
    !accessTokenPart3 &&
    !refreshTokenData
  ) {
    return (
      <ValidateUserContext.Provider value={null}>
        {props.children}
      </ValidateUserContext.Provider>
    );
  }
  const { user_email, user_name, user_roles, organization_metadata } =
    parseJwtToken(
      [
        accessTokenPart1?.access_token_part_1,
        accessTokenPart2?.access_token_part_2,
        accessTokenPart3?.access_token_part_3,
      ].join(''),
    );
  return (
    <ValidateUserContext.Provider
      value={{
        amgId: organization_metadata.domain,
        user_email_id: user_email,
        user_name,
        user_role: user_roles,
      }}
    >
      {props.children}
    </ValidateUserContext.Provider>
  );
};

export function useStvV2UserData(): ILoginDataStvV2 {
  const loginData = useContext(ValidateUserContext);
  if (!loginData) {
    gotoSignInPage({
      shouldSavePreviousRoute: true,
    });
    throw new Error(
      'tried to consume context outside provider or user not logged in',
    );
  }
  return loginData;
}
